interface AppNameSource {
  name?: string | null
  module_id?: string | null
  app_id?: string | null
  id?: string | null
}

/** 详情或创建已经确认过的展示名。刷新页面后清空，和内存里的应用缓存一起失效。 */
const confirmedNames = new Map<string, string>()

export function confirmDisplayName(appId: string | undefined, name: string | undefined) {
  const id = appId?.trim() ?? ''
  const next = name?.trim() ?? ''
  if (!id || !next) return
  confirmedNames.set(id, next)
}

/** 测试隔离 */
export function clearConfirmedDisplayNames() {
  confirmedNames.clear()
}

function isConfirmedDisplayName(app: AppNameSource): boolean {
  const appId = (app.app_id || app.id)?.trim()
  const name = app.name?.trim() ?? ''
  if (!appId || !name) return false
  return confirmedNames.get(appId) === name
}

/** 列表常把模块 ID 或平台 AppID 填进 name。这种值不能当平台展示名先画出来。 */
export function isUntrustedDisplayName(app: AppNameSource): boolean {
  if (isConfirmedDisplayName(app)) return false
  const name = app.name?.trim() ?? ''
  if (!name) return true
  const moduleId = app.module_id?.trim()
  const appId = (app.app_id || app.id)?.trim()
  if (moduleId && name === moduleId) return true
  if (appId && name === appId) return true
  return false
}

/** 列表回填：已有可信展示名时，不用模块 ID 把它盖掉 */
export function mergeListAppName(
  existingName: string | undefined,
  incomingName: string,
  ids: { module_id?: string; app_id?: string },
): string {
  const incoming = incomingName.trim()
  const existing = existingName?.trim() ?? ''
  const source = { module_id: ids.module_id, app_id: ids.app_id }
  if (incoming && !isUntrustedDisplayName({ ...source, name: incoming })) return incoming
  if (existing && !isUntrustedDisplayName({ ...source, name: existing })) return existing
  return incoming || existing
}
